import { Injectable } from '@angular/core';
import { CanActivate, CanMatch, Router, UrlTree, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { firstValueFrom, from, Observable, of } from 'rxjs';
import { catchError, map, switchMap, take } from 'rxjs/operators';
import { Auth, authState, User } from '@angular/fire/auth';
import { Database, DatabaseReference, DataSnapshot, get, ref } from '@angular/fire/database';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate, CanMatch {

  constructor(
              private afAuth: Auth,
              private router: Router,
              private database: Database
            ) {}

  // private checkAccess(): Observable<any> {
  //   return authState(this.afAuth).pipe(take(1), switchMap((user: User | null) => {
  //     if (!user) return of (this.router.navigate(['/sign-in']));
  //     const uid: string = user.uid;
  //     const userRef: DatabaseReference = ref(this.database, `CarFinderGeniePlatform/customers/${uid}`);
  //     return get(userRef).then((snapshot: DataSnapshot) => {
  //       if (!snapshot.exists()) return this.router.navigate(['/sign-in']);
  //       const userData = snapshot.val();
  //       // Supongamos que el rol válido para entrar es "admin"
  //       if (userData.user_type === 'customer') {
  //         return true;
  //       } else {
  //         // Si el usuario está logueado pero no tiene acceso, cerramos sesión y lo redirigimos
  //         this.afAuth.signOut().then(() => {
  //           return this.router.navigate(['/sign-in']);
  //         })
  //       }
  //     });
  //   }),
  //   catchError(() => of(this.router.navigate(['/sign-in']))));
  // }

  private async checkAccessInternal(): Promise<boolean | UrlTree> {
    const user = await firstValueFrom(authState(this.afAuth));
    if (!user) return this.router.createUrlTree(['/sign-in']);
    const uid = user.uid;
    const userRef = ref(this.database, `CarFinderGeniePlatform/customers/${uid}`);
    const snapshot = await get(userRef);
    if (!snapshot.exists()) return this.router.createUrlTree(['/sign-in']);
    const userData = snapshot.val();
    if (userData.user_type === 'customer') {
      return true;
    }
    await this.afAuth.signOut();
    return this.router.createUrlTree(['/sign-in']);
  }

  private checkAccess(): Observable<boolean | UrlTree> {
    return from(this.checkAccessInternal());
  }


  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | any> {
    return this.checkAccess();
  }

  canMatch(): Observable<boolean | any> {
    return this.checkAccess();
  }
}
